import InputWithLabel from "app/components/FormInputs/components/InputWithLabel/InputWithLabel";
import {
  RegistrationFormModalFieldNames,
  registrationInputMaxLength,
} from "app/utils/const";
import { IntlShape } from "react-intl";
type Props = {
  intl: IntlShape;
  promoCode: string;
  handleChange: (id: string, value: string) => void;
  promoCodeValidationError: boolean;
};

const PromoCode = ({ intl, promoCode, handleChange }: Props) => {
  return (
    <div className="form-details__row promo-code">
      <InputWithLabel
        label={intl.formatMessage({
          id: "registration-form-promoCode",
        })}
        inputId={RegistrationFormModalFieldNames.promoCode}
        value={promoCode}
        onValueChange={handleChange}
        key={RegistrationFormModalFieldNames.promoCode}
        maxLength={registrationInputMaxLength.emailMaxLength}
        icon={""}
        placeholder={intl.formatMessage({
          id: "registration-form-enter-code",
        })}
        validateInput={true}
      />
    </div>
  );
};

export default PromoCode;
